/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { CheckCardBin } from "./CheckCardBin";
import * as t from "io-ts";

// required attributes
const CheckCardBinResponseR = t.interface({});

// optional attributes
const CheckCardBinResponseO = t.partial({
  data: CheckCardBin
});

export const CheckCardBinResponse = t.intersection(
  [CheckCardBinResponseR, CheckCardBinResponseO],
  "CheckCardBinResponse"
);

export type CheckCardBinResponse = t.TypeOf<typeof CheckCardBinResponse>;
